<template>
  <div class="Box">
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="32">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="4" class="mb20">
            <el-form-item label="额度:">
              <el-input v-model="queryParams.money" @change="search" clearable @clear="search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="4" class="mb20">
            <el-form-item label="天数:">
              <el-input v-model="queryParams.day" @change="search" clearable @clear="search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" class="mb20">
            <el-button size="medium" type="primary" @click="search">查询</el-button>
            <el-button size="medium" @click="addNoNe">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="getList">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" size="medium" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectionChange" border :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }" v-loading="loading">

        <el-table-column label="VIP金额">
          <template slot-scope="scope">{{ scope.row.money }}</template>
        </el-table-column>
        <el-table-column label="VIP天数">
          <template slot-scope="scope">{{ scope.row.day }}</template>
        </el-table-column>
        <el-table-column label="提示语">
          <template slot-scope="scope">{{ scope.row.description }}</template>
        </el-table-column>
        <el-table-column label="更新结束时间">
          <template slot-scope="scope">{{ scope.row.created_at }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
        @pagination="getList" />

      <div class="drawer-wrapper">
        <el-drawer :wrapperClosable="true" :title="title" :close-on-click-modal="false"
          :visible.sync="dialogFormVisible" size="50%" :before-close="handleClose">
          <div class="demo-drawer__content">

            <el-form ref="ruleForm" :model="formAdd" :rules="rules" size="medium">

              <el-row :gutter="35">

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
                  <el-form-item label="VIP金额" prop="money">
                    <el-input v-model="formAdd.money" autocomplete="off" placeholder="请输入VIP金额"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
                  <el-form-item label="VIP天数" prop="day">
                    <el-input v-model="formAdd.day" autocomplete="off" placeholder="请输入VIP天数"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
                  <el-form-item label="提示语" prop="description">
                    <el-input v-model="formAdd.description" autocomplete="off" placeholder="请输入提示语"></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-form>

          </div>

          <div class="demo-drawer__footer">
            <el-button @click="handleCloseDone">取消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
          </div>

        </el-drawer>
      </div>
    </el-card>
  </div>
</template>

<script>
import { VipApi } from '@/api/vipRecharge/index';
import { processErrors } from "@/utils/errorHandler";

export default {
  components: {},
  data() {
    return {
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        money: '',
        day: '',
      },
      formAdd: {
        id: null,
        money: '',
        day: '',
        description: '',
      },
      // 总条数
      total: 0,
      tableData: [],
      multipleSelection: [],
      // 抖音添加修改弹窗
      dialogFormVisible: false,
      rules: {
        money: [{ required: true, message: '请输入VIP金额', trigger: 'blur' }],
        day: [{ required: true, message: '请输入VIP天数', trigger: 'blur' }],
        description: [{ required: true, message: '请输入提示语', trigger: 'blur' }],
      },
      title: '',
      formLabelWidth: '80px',
      loading: false
    };
  },
  methods: {
    getList() {
      this.loading = true;
      const api = VipApi();
      api.getvipList(this.queryParams)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.total = res.data.totalCount;
          } else {
            processErrors(res);
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
          this.loading = false;
        });
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        money: '',
        day: '',
      };
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

    },

    search() {
      this.getList();
    },
    //删除
    handleDel(row) {
      this.$confirm('确定删除这个项吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 用户点击确认时，执行删除操作
          const api = VipApi();
          const id = row.id;
          api.getGoods_vipDel(id).then((response) => {
            this.$message({
              message: '删除成功',
              type: 'success',
            });
            this.getList();
          }).catch(error => {
            this.$message({
              message: '删除失败',
              type: 'error',
            });
          });
        })
        .catch(() => {
          // 用户点击取消时，不做任何操作
          this.$message({
            message: '删除操作已取消',
            type: 'info',
          });
        });
    },
    //添加弹窗
    handleAdd() {
      // this.resetFrom();
      this.formAdd = {
        id: null,
        money: '',
        day: '',
        description: '',
      };
      this.dialogFormVisible = true;
      this.title = '添加';
    },
    // 关闭弹窗
    handleClose(done) {
      done();
      this.$refs['ruleForm'].resetFields();
    },
    handleCloseDone() {
      this.$refs['ruleForm'].resetFields();
      this.dialogFormVisible = false
    },
    handleUpdate(row) {
      // this.resetFrom();
      this.dialogFormVisible = true;

      const api = VipApi();
      const id = row.id || this.ids;
      api.getGoods_vipInfoDetil(id).then((response) => {
        this.title = '修改';
        this.formAdd = response.data;
      });
    },
    //添加
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.formAdd.id == null) {

            const api = VipApi();
            api.getGoods_vipInfo(this.formAdd).then((response) => {
              this.$message({
                message: '添加成功',
                type: 'success',
              });

              this.dialogFormVisible = false;
              this.getList();
            });
          } else {

            const api = VipApi();
            api.getGoods_vipInfo(this.formAdd).then((response) => {
              this.$message({
                message: '修改成功',
                type: 'success',
              });
              this.dialogFormVisible = false;
              this.getList();
            });
          }
        }
      });
    },

  },
  mounted() {
    this.getList();
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.form-wrapper {
  padding-bottom: 80px;
  /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

.demo-drawer__content {
  height: calc(100% - 80px);
  overflow-y: auto;
  padding: 20px;
  overflow-x: hidden;
}

.el-form-item {
  margin-bottom: 0;
}

.el-form-item__label {
  font-size: 14px;
  color: #606266;
}

.el-input {
  width: 100%;
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
</style>
